import { Typography } from "@mui/material";
import PageContainer from "../../app/common/page/PageContainer";


export default function NotFound() {
    return (
        <PageContainer pagetitle="404 Not Found">
            <Typography component="h1" variant="h6">
                Not Found
            </Typography>
        </PageContainer>
    )
}